import React, { useEffect, useState } from 'react'
import { Button, Tree, message, Input, Tabs } from 'antd'
import { YhBox } from '@/components/YhBox'
import { FormBox } from './FormBox'
import { EventDataNode, DataNode } from 'antd/lib/tree'
import { useDictModel } from '../assetsAskModel'
import { IDictDetail, IDictSearch } from '../assetsAskService'
import { DeleteOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { useOrgModel } from '../../organization/orgModel'
import { IVRMOrgDetail } from '../../organization/orgService'

export const DataBox = () => {
    //查询条件
    const [searchParam, setSearchParam] = useState<IDictSearch>()
    const { treeSource,loadData, setMode, setSelectedNodes, selectedNodes, setFormVal,} = useDictModel()
    const { treeSource:orgTreeSource, loadData:orgLoadData, setSelectedNodes:setorgSelectedNodes, selectedNodes:orgSelectedNodes,  } = useOrgModel();
    const [searchData, setSearchData] = useState([...treeSource])

    useEffect(() => {
        loadData()
    }, [])

    //字典选中事件
    const onSelect = (
        selectedKeys: React.Key[],
        info: {
            event: 'select'
            selected: boolean
            node: EventDataNode
            selectedNodes: DataNode[]
            nativeEvent: MouseEvent
        }
    ) => {
        let selectNode = info.selectedNodes as IDictDetail[]
        console.log(info)
        setMode('look')
        setSelectedNodes(selectNode)
    }
    //字典选中事件
    const onOrgSelect = (
        selectedKeys: React.Key[],
        info: {
            event: 'select'
            selected: boolean
            node: EventDataNode
            selectedNodes: DataNode[]
            nativeEvent: MouseEvent
        }
    ) => {
        let selectNode = info.selectedNodes as IVRMOrgDetail[]
        setorgSelectedNodes(selectNode)
        setSelectedNodes([])
    }
    return (
        <YhBox>
            <div className="dict-container flex">
            <div className="dict-list-box">
                    <Tree
                        defaultExpandedKeys={[orgSelectedNodes[0]?.key]}
                        selectedKeys={[orgSelectedNodes[0]?.key]}
                        titleRender={(node: any) => `${node.name}`}
                        onSelect={onOrgSelect}
                        treeData={orgTreeSource}
                    />
                </div>
                {treeSource.length > 0&&orgSelectedNodes.length>0 && (
                    <>
                <div style={{ borderRight: '1px solid #e0e0e0', margin: '10px 10px' }}></div>
                <div className="dict-list-box">
                    <span className="dict-list-title">申请配置</span>
                    <div style={{ float: 'right',marginBottom:'20px' }}>
                        <div>
                            <Button className="mr-5" type="primary" shape="round"
                                onClick={() => {
                                    if (!selectedNodes.length) {
                                        message.warning('请选择要完善的申请类型！')
                                        return
                                    }
                                    message.success('添加申请配置')
                                    setMode('add')
                                }}
                            > 添加审批 </Button>
                        </div>
                    </div>
                    
                        <div className="dict-list-boxs">
                            <Tree
                                defaultExpandedKeys={[selectedNodes[0]?.key]}
                                selectedKeys={[selectedNodes[0]?.key]}
                                //titleRender={(node: any) => `${node.name}`}
                                defaultExpandAll={treeSource.length !== searchData.length}
                                titleRender={(node: any) => (
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{node.name}</span>
                                    </div>
                                )}
                                blockNode
                                onSelect={onSelect}
                                treeData={treeSource}
                            />
                        </div>
                    
                </div>
                </>
                )}
                <div style={{ borderRight: '1px solid #e0e0e0', margin: '10px 0' }}></div>
                <div className="dict-from-box flex">
                    {selectedNodes.length > 0 ? <FormBox /> : <div className="dict-init-box flex flex-1 items-center justify-center">申请配置</div>}
                </div>
            </div>
        </YhBox>
    )
}
